import { images } from '../constants'; 


const emergencyIntro = {
    sub: "Locksmith Emergency Services",
    heading: "Contact Us for Emergency Locksmith Assistance",
    description:
        "For urgent locksmith assistance, contact Locksmith's emergency services. We're available 24/7 to help with lockouts, key replacements, and more. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "24/7 Emergency Locksmith Services",
        "Quick Response to Lockout Situations",
        "Key Replacement and Lock Repair",
        "Professional and Reliable Assistance",
        "Efficient Locksmith Solutions",
    ],
    image: {
        src: images.emergencyIntro,
        alt: "Emergency Image",
    },
};


const emergencyServices = [
    {
        id: 1,
        image: images.emergencyService1,
        title: 'Lockout Help',
        content: 'Rapid response for lockout situations, ensuring you regain access to your property quickly.',
        paragraphs: [
            'Locked out of your home, car, or office? Our emergency lockout help is just a call away. We understand how stressful lockouts can be, which is why we prioritize fast arrival and efficient service.',
            'Our experienced locksmiths use non-destructive methods whenever possible to get you back inside safely and without damage. Available 24/7, we’re here to assist you during emergencies with speed and professionalism.'
        ],
        gallery: [
            images.emergencyService1Gallery1,
            images.emergencyService1Gallery2,
        ],
        features: [
            '24/7 Emergency Availability',
            'Home, Office & Vehicle Access',
            'Non-Destructive Entry Methods',
            'Rapid Response Times',
            'Licensed & Insured Technicians'
        ],
        procedure: [
            'Receive Emergency Call',
            'Location Verification & Dispatch',
            'On-Site Assessment',
            'Non-Destructive Entry (if possible)',
            'Access Restored & Optional Lock Replacement'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What should I do if I’m locked out?',
                content: 'Stay calm and contact us immediately. Provide your location and any relevant details so we can respond quickly.'
            },
            {
                id: 2,
                heading: 'Can you help with vehicle lockouts?',
                content: 'Yes, we handle lockouts for cars, trucks, and other vehicles using specialized tools to avoid damage.'
            },
            {
                id: 3,
                heading: 'Will my lock be damaged during the process?',
                content: 'We always attempt non-destructive entry first. In most cases, we can get you back in without harming your lock or door.'
            },
            {
                id: 4,
                heading: 'How fast can you arrive?',
                content: 'Response times vary by location, but we strive to arrive within 20–30 minutes in most service areas.'
            }
        ]
    },
    {
        id: 2,
        image: images.emergencyService2,
        title: 'Lock Repair',
        content: 'Immediate repair of damaged or malfunctioning locks to restore security to your property.',
        paragraphs: [
            'Don’t compromise on security due to a faulty lock. Our lock repair services address issues ranging from jammed mechanisms to worn-out components, ensuring your locks function smoothly and reliably.',
            'Whether it’s a residential, commercial, or automotive lock, our technicians diagnose and repair the problem quickly on-site. We restore your peace of mind with professional workmanship and durable solutions.'
        ],
        gallery: [
            images.emergencyService2Gallery1,
            images.emergencyService2Gallery2,
        ],
        features: [
            'Repair for All Lock Types',
            'Residential, Commercial & Automotive',
            'Fix Jams, Misalignments & Wear',
            'On-the-Spot Diagnosis & Repair',
            'Trusted & Skilled Locksmiths'
        ],
        procedure: [
            'Issue Assessment & Diagnosis',
            'Lock Disassembly (if needed)',
            'Repair or Replace Faulty Components',
            'Function Testing & Reassembly',
            'Final Security Check'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What kinds of lock problems do you repair?',
                content: 'We repair jammed locks, broken keyholes, worn mechanisms, misaligned components, and more across all types of locks.'
            },
            {
                id: 2,
                heading: 'Can my lock be repaired or does it need replacing?',
                content: 'Our technicians assess the damage and recommend the best option. Many issues can be repaired without needing full replacement.'
            },
            {
                id: 3,
                heading: 'How long does a lock repair take?',
                content: 'Most repairs take 30–60 minutes depending on the issue. Complex problems may take longer.'
            },
            {
                id: 4,
                heading: 'Do you provide repair services after hours?',
                content: 'Yes, we offer emergency repair services 24/7 to restore your security without delay.'
            }
        ]
    },
    {
        id: 3,
        image: images.emergencyService3,
        title: 'Key Replacement',
        content: 'Swift replacement of lost, stolen, or broken keys to restore access to your property.',
        paragraphs: [
            'Lost your keys or dealing with a broken one? Our key replacement service ensures you regain secure access to your property without delay. We cut and program keys for homes, businesses, and vehicles on the spot.',
            'From standard house keys to advanced transponder or smart keys, we use precision tools and up-to-date technology to deliver accurate replacements quickly and reliably.'
        ],
        gallery: [
            images.emergencyService3Gallery1,
            images.emergencyService3Gallery2,
        ],
        features: [
            'Residential, Commercial & Automotive Keys',
            'On-Site Key Cutting & Programming',
            'Lost Key Replacement',
            'Transponder & Smart Key Services',
            'Fast Turnaround Time'
        ],
        procedure: [
            'Request & Identity Verification',
            'Key Type Identification',
            'On-Site Key Cutting or Programming',
            'Functionality Testing',
            'Delivery & Optional Spare Key'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of keys can you replace?',
                content: 'We replace house keys, office keys, car keys, transponder keys, and smart keys for a wide range of lock systems.'
            },
            {
                id: 2,
                heading: 'Can you make a key without the original?',
                content: 'Yes, we can generate a new key based on the lock or key code, even if the original is lost.'
            },
            {
                id: 3,
                heading: 'Do you offer car key replacements?',
                content: 'Absolutely. We replace and program car keys, including key fobs and transponder keys, for many makes and models.'
            },
            {
                id: 4,
                heading: 'How long does key replacement take?',
                content: 'Most key replacements are completed within 30–45 minutes, depending on the key type and complexity.'
            }
        ]
    },
    {
        id: 4,
        image: images.emergencyService4,
        title: 'Damage Fix',
        content: 'Immediate repair of locks and doors damaged during a break-in to secure your property.',
        paragraphs: [
            'If your home, office, or vehicle has suffered a break-in, restoring your security is our top priority. Our damage fix service focuses on repairing or replacing compromised locks, doors, and entry points swiftly and effectively.',
            'We assess the extent of the damage and provide durable repairs or upgrades to ensure your property is secure again. With emergency availability, we’re here when you need urgent assistance the most.'
        ],
        gallery: [
            images.emergencyService4Gallery1,
            images.emergencyService4Gallery2,
        ],
        features: [
            'Emergency Post-Break-In Repairs',
            'Lock & Door Replacement Options',
            'Security Upgrade Recommendations',
            'Fast On-Site Response',
            'Insurance-Approved Repair Reports'
        ],
        procedure: [
            'Emergency Response & Damage Assessment',
            'Lock & Entry Point Inspection',
            'Immediate Securing of Property',
            'Repair or Replacement of Damaged Components',
            'Security Testing & Recommendations'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What should I do after a break-in?',
                content: 'Ensure your safety first, then contact authorities. Once safe, reach out to us for urgent lock and door repair services.'
            },
            {
                id: 2,
                heading: 'Can you replace both the lock and the door?',
                content: 'Yes, we can replace or repair both locks and doors, depending on the extent of the damage.'
            },
            {
                id: 3,
                heading: 'Do you provide documentation for insurance claims?',
                content: 'Yes, we offer detailed repair reports and invoices that can be submitted to your insurance provider.'
            },
            {
                id: 4,
                heading: 'How quickly can you respond to an emergency?',
                content: 'We offer 24/7 emergency response and aim to arrive within 30 minutes in most areas.'
            }
        ]
    },
    {
        id: 5,
        image: images.emergencyService5,
        title: 'Safe Opening',
        content: 'Expert unlocking of safes during emergencies to retrieve valuables or important documents.',
        paragraphs: [
            'Locked out of your safe or forgotten the combination? Our safe opening specialists use advanced techniques to open safes without causing damage, preserving your valuables and peace of mind.',
            'We handle all types of safes, including fireproof, biometric, electronic, and traditional mechanical safes. Available for emergency and scheduled services, we ensure prompt, professional, and confidential assistance.'
        ],
        gallery: [
            images.emergencyService5Gallery1,
            images.emergencyService5Gallery2,
        ],
        features: [
            'Opening of All Safe Types',
            'Non-Destructive Techniques',
            'Emergency & Scheduled Service',
            'Confidential & Professional',
            'Certified Safe Technicians'
        ],
        procedure: [
            'Initial Consultation & Safe Type Identification',
            'Assessment of Locking Mechanism',
            'Application of Non-Destructive Opening Methods',
            'Safe Access & Inspection',
            'Optional Repair or Re-locking Services'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can you open all types of safes?',
                content: 'Yes, we work with mechanical, electronic, biometric, and fireproof safes of all sizes.'
            },
            {
                id: 2,
                heading: 'Will my safe be damaged during opening?',
                content: 'We prioritize non-destructive methods to preserve your safe and its contents whenever possible.'
            },
            {
                id: 3,
                heading: 'How long does safe opening take?',
                content: 'Safe opening times vary depending on the model and locking mechanism but typically range from 30 minutes to a few hours.'
            },
            {
                id: 4,
                heading: 'Do you offer emergency safe opening?',
                content: 'Yes, emergency safe opening services are available 24/7.'
            }
        ]
    },
    {
        id: 6,
        image: images.emergencyService6,
        title: 'Anytime Assistance',
        content: 'Round-the-clock availability for all your emergency locksmith needs.',
        paragraphs: [
            'Emergencies don’t wait for business hours, and neither do we. Our locksmith team is available 24/7 to respond to your urgent lock and key issues anytime, day or night.',
            'Whether you’re locked out, need a quick repair, or require immediate security upgrades, our prompt and professional locksmiths are just a call away, ready to assist you whenever you need.'
        ],
        gallery: [
            images.emergencyService6Gallery1,
            images.emergencyService6Gallery2,
        ],
        features: [
            '24/7 Emergency Locksmith Services',
            'Rapid Response at Any Hour',
            'Residential, Commercial & Automotive',
            'Experienced & Licensed Technicians',
            'Reliable & Professional Support'
        ],
        procedure: [
            'Emergency Call Received',
            'Location & Situation Assessment',
            'Technician Dispatched Immediately',
            'On-Site Emergency Locksmith Service',
            'Service Completion & Follow-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Are you really available 24/7?',
                content: 'Yes, our locksmith services are available 24 hours a day, 7 days a week, including holidays.'
            },
            {
                id: 2,
                heading: 'How quickly can you respond at night?',
                content: 'We strive to reach emergency calls within 20–30 minutes regardless of the time.'
            },
            {
                id: 3,
                heading: 'Do you charge extra for after-hours service?',
                content: 'Emergency and after-hours service fees may apply, but we provide upfront pricing before work begins.'
            },
            {
                id: 4,
                heading: 'Can I schedule a service for late night or early morning?',
                content: 'Yes, you can schedule emergency or urgent locksmith services at any hour.'
            }
        ]
    }

];

const emergencyFaqs = [
    {
        id: 1,
        heading: 'What are the emergency procedures?',
        content: 'Learn about the step-by-step emergency procedures to follow during fire incidents. Be prepared and stay safe by understanding the recommended actions.',
    },
    {
        id: 2,
        heading: 'How is firefighting equipment maintained?',
        content: 'Explore details about the maintenance practices ensuring our firefighting equipment remains in optimal condition, ready for immediate use when needed.',
    },
    {
        id: 3,
        heading: 'What community fire safety initiatives do you have?',
        content: 'Discover our initiatives aimed at educating and engaging the community in fire safety practices. Learn how you can actively participate and contribute to a safer neighborhood.',
    },
    {
        id: 4,
        heading: 'How can I report a fire incident?',
        content: 'Understand the process for reporting fire incidents. Whether through our online reporting system or direct contact, we ensure a swift response to every reported incident.',
    },
    {
        id: 5,
        heading: 'Do you provide fire prevention tips?',
        content: 'Access valuable tips and recommendations for preventing fire hazards. Learn how to safeguard your home and community from potential fire risks.',
    },
];


export { emergencyIntro, emergencyServices, emergencyFaqs };